import { dictionary } from "@/schemas/dictionary";
import { z } from "@/zod";

const payrollDepartment = dictionary.extend({
  description: z.string().optional(),
  shift_report_department_id: z.string().length(26).optional(),
  shift_report_department: z.string().optional(),
  payroll_type_id: z.string().length(26).optional(),
  payroll_type: z.string().optional(),
});

export const readPayrollDepartment = payrollDepartment.readonly();

export const writePayrollDepartment = payrollDepartment.omit({
  id: true,
  shift_report_department: true,
  payroll_type: true,
});
